export interface NavAccentContext {
  charityNavDark: boolean;
  useCharityNav: boolean;
  useProgramsNav: boolean;
  isLight: boolean;
}

export function getNavOverlay(
  ctx: NavAccentContext,
  isScrolled: boolean
): boolean {
  return ctx.useCharityNav && !isScrolled;
}

export function getNavLightText(
  ctx: NavAccentContext,
  isScrolled: boolean
): boolean {
  if (ctx.useCharityNav && !isScrolled) return true;
  if (!ctx.isLight) return true;
  return false;
}

export function getNavLinkClass(
  active: boolean,
  ctx: NavAccentContext,
  isScrolled: boolean
): string {
  if (getNavLightText(ctx, isScrolled)) {
    return active ? "text-white" : "text-white/85 hover:text-white";
  }

  if (ctx.useCharityNav) {
    return active
      ? "text-[var(--charity-green-dark)]"
      : "text-gray-700 hover:text-[var(--charity-green-dark)]";
  }

  if (ctx.useProgramsNav) {
    return active
      ? "text-[var(--programs-green-dark)]"
      : "text-gray-700 hover:text-[var(--programs-green-dark)]";
  }

  return active ? "text-primary" : "text-gray-700 hover:text-primary";
}

export function getNavUnderlineClass(
  ctx: NavAccentContext,
  isScrolled: boolean
): string {
  if (getNavLightText(ctx, isScrolled)) {
    return ctx.useCharityNav && !ctx.isLight
      ? "bg-[var(--charity-gold)]"
      : "bg-white";
  }

  if (ctx.useCharityNav) {
    return "bg-[var(--charity-green)]";
  }

  if (ctx.useProgramsNav) {
    return "bg-[var(--programs-green)]";
  }

  return "bg-primary";
}

export function getNavPillHighlightClass(
  ctx: NavAccentContext,
  isScrolled: boolean
): string {
  if (getNavLightText(ctx, isScrolled)) {
    return "bg-white/[0.08]";
  }

  return "bg-black/[0.06]";
}
